import { Breadcrumbs } from "../components/Breadcrumbs";

function Servico() {
    return (
        <div>
            <Breadcrumbs currentPage="Serviços" />
            <header className="page-header">
                <h2 className="page-title">Gestão de Serviços</h2>
            </header>
            <div className="table-placeholder">
                Módulo de Serviços em construção.
            </div>
        </div>
    );
}

export default Servico;
